// @flow
import styled from 'styled-components';

export const GameBarWrapper = styled.div`
	background: #FFF;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	padding: 0 1em;
`;

export default GameBarWrapper;


// WEBPACK FOOTER //
// ./src/components/GameBarWrapper/index.js